module.exports = __webpack_public_path__ + "banquet/containers/MarketingPricingContainer/images/customers.e178cf524c63bddf28a1744314456318.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/containers/MarketingPricingContainer/images/customers.svg
// module id = 1717
// module chunks = 1